import { render, staticRenderFns } from "./EditPreparationTimeModal.vue?vue&type=template&id=3f537540&scoped=true"
import script from "./EditPreparationTimeModal.vue?vue&type=script&lang=js"
export * from "./EditPreparationTimeModal.vue?vue&type=script&lang=js"
import style0 from "./EditPreparationTimeModal.vue?vue&type=style&index=0&id=3f537540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f537540",
  null
  
)

export default component.exports